/*
 * Minicart Lifters: productos recomendados con agregar directo al carrito.
 * El contenido del drawer se re-renderiza en cada cambio del carrito, por eso
 * todo funciona con delegación de eventos sobre document.
 */
(function () {
  if (window.lfCartDrawerLoaded) return;
  window.lfCartDrawerLoaded = true;

  const RECS_STATE_KEY = 'lfRecsMobileOpen';

  function getVariants(card) {
    const script = card.querySelector('[data-lf-rec-variants]');
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return [];
    }
  }

  function updateCard(card) {
    const selects = Array.from(card.querySelectorAll('[data-lf-rec-option]'));
    const values = selects.map((select) => select.value);
    const variant = getVariants(card).find((v) => v.options.every((option, i) => option === values[i]));

    const button = card.querySelector('[data-lf-rec-add]');
    const label = card.querySelector('[data-lf-rec-label]');
    const error = card.querySelector('[data-lf-rec-error]');
    error.hidden = true;

    if (!variant) {
      button.disabled = true;
      label.textContent = button.dataset.labelUnavailable;
      return;
    }

    button.dataset.variantId = variant.id;
    button.disabled = !variant.available;
    label.textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelSoldout;

    card.querySelector('[data-lf-rec-price]').textContent = variant.price;
    const compare = card.querySelector('[data-lf-rec-compare]');
    compare.hidden = !variant.compare;
    compare.textContent = variant.compare || '';

    const image = card.querySelector('[data-lf-rec-img]');
    if (image && variant.image) image.src = variant.image;
  }

  async function addToCart(button) {
    const card = button.closest('[data-lf-rec]');
    const label = card.querySelector('[data-lf-rec-label]');
    const error = card.querySelector('[data-lf-rec-error]');
    const drawer = document.querySelector('cart-drawer');

    button.disabled = true;
    button.classList.add('is-loading');
    label.textContent = 'Agregando…';
    error.hidden = true;

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'No se pudo agregar el producto');
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lf-cart-recs', cartData: data });
      }

      // Tras agregar, el desplegable mobile vuelve a quedar cerrado
      try {
        sessionStorage.setItem(RECS_STATE_KEY, '0');
      } catch (e) {}

      // Re-renderiza el drawer completo (el producto agregado sale de la lista de recomendados)
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      }
    } catch (e) {
      error.textContent = e.message;
      error.hidden = false;
      button.disabled = false;
      label.textContent = button.dataset.labelAdd;
    } finally {
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-lf-rec-option]');
    if (select) updateCard(select.closest('[data-lf-rec]'));
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-lf-rec-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    addToCart(button);
  });

  // Desplegable mobile: cerrado por defecto, pero respeta si el cliente lo abrió
  document.addEventListener(
    'toggle',
    (event) => {
      if (!event.target.matches || !event.target.matches('.lf-recs--mobile')) return;
      try {
        sessionStorage.setItem(RECS_STATE_KEY, event.target.open ? '1' : '0');
      } catch (e) {}
    },
    true
  );

  function restoreRecsState() {
    let state = null;
    try {
      state = sessionStorage.getItem(RECS_STATE_KEY);
    } catch (e) {}
    if (state !== '1') return;
    document.querySelectorAll('.lf-recs--mobile:not([open])').forEach((details) => {
      details.open = true;
    });
  }

  /*
   * Recomendados dinámicos: por cada producto del carrito pide sus relacionados
   * (Search & Discovery, intent=related) y toma N de cada uno. Si no hay ninguno,
   * se queda la lista de respaldo (colección) que ya viene pintada desde Liquid.
   */
  const relatedCache = new Map(); // "productId:limit" -> Promise<[{id, html}]>

  function fetchRelated(baseUrl, productId, limit) {
    const cacheKey = `${productId}:${limit}`;
    if (!relatedCache.has(cacheKey)) {
      const url = `${baseUrl}?section_id=lf-cart-recommendations&product_id=${productId}&limit=${limit}&intent=related`;
      const request = fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          return Array.from(doc.querySelectorAll('.lf-recs-source [data-lf-rec]')).map((card) => ({
            id: card.dataset.productId,
            html: card.outerHTML,
          }));
        })
        .catch(() => {
          relatedCache.delete(cacheKey);
          return [];
        });
      relatedCache.set(cacheKey, request);
    }
    return relatedCache.get(cacheKey);
  }

  async function buildDynamicCards(list) {
    const cartIds = list.dataset.cartIds.split(',').filter(Boolean);
    const perProduct = Number(list.dataset.perProduct) || 2;
    const max = Number(list.dataset.max) || 8;
    // Pide de más para compensar repetidos y productos que ya están en el carrito
    const limit = Math.min(perProduct + cartIds.length + 2, 10);

    const results = await Promise.all(cartIds.map((id) => fetchRelated(list.dataset.recsUrl, id, limit)));

    const used = new Set(cartIds);
    const cards = [];
    results.forEach((related) => {
      let taken = 0;
      for (const card of related) {
        if (taken >= perProduct || cards.length >= max) break;
        if (used.has(card.id)) continue;
        used.add(card.id);
        cards.push(card.html);
        taken++;
      }
    });
    return cards;
  }

  async function refreshDynamicRecs() {
    const lists = document.querySelectorAll('[data-lf-recs-dynamic]:not([data-lf-resolved])');
    if (!lists.length) return;
    lists.forEach((list) => list.setAttribute('data-lf-resolved', 'loading'));

    let cards = [];
    try {
      cards = await buildDynamicCards(lists[0]);
    } catch (e) {
      cards = [];
    }

    lists.forEach((list) => {
      if (!list.isConnected) return; // el drawer se re-renderizó mientras cargaba
      if (cards.length) {
        list.innerHTML = cards.map((html) => html.replaceAll('__UID__', list.dataset.uid)).join('');
      }
      list.setAttribute('data-lf-resolved', 'done');
      const block = list.closest('.lf-recs');
      if (block) block.classList.remove('lf-recs--pending');
    });
  }

  function onDrawerChange() {
    restoreRecsState();
    refreshDynamicRecs();
  }

  function init() {
    onDrawerChange();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(onDrawerChange).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
